/* eslint-disable import/prefer-default-export */

const axios = require('axios').default;
import { toastError, toastSuccess } from '../../../shared/toastHelper';
import {
  VENUE_SELECTED_CHANGED,
  EVENTS_CHANGED,
  CALENDAR_EVENT_CONFLICTS_CHANGED,
  OPEN_CALENDAR_EVENT_CONFLICTS_MODAL,
  CLOSE_CALENDAR_EVENT_CONFLICTS_MODAL,
  USER_UPDATED,
  CALENDAR_EVENT_CONFLICTS_MERGE_CHECKBOX_CLICKED,
  TOGGLE_ON_SALE_ENABLED,
  TOGGLE_PRE_SALE_ENABLED,
  TOGGLE_ARTIST_PRE_SALE_ENABLED,
  TOGGLE_ANNOUNCED_ENABLED,
  TOGGLE_CONFIRMED_ENABLED,
  TOGGLE_HOLDS_ENABLED,
  TOGGLE_PAST_EVENTS_ENABLED,
  TOGGLE_CANCELLED_EVENTS_ENABLED,
  DATA_TABLE_FILTERS_CHANGED,
  RELOAD_DATA_TABLE,
  DATA_TABLE_EL_CHANGED,
  SEARCH_TERM_CHANGED,
  CURRENT_TEAM_MEMBERSHIP_CHANGED,
  CHECK_AVAILS_IS_OPEN_CHANGED,
  CHECK_AVAILS_SETTINGS_CHANGED,
  CALENDAR_SYNC_IS_OPEN_CHANGED,
  CHECK_AVAILS_DATES_CHANGED,
  CHECK_AVAILS_CALENDAR_EVENTS_CHANGED,
  CHECK_AVAILS_LOADING_CHANGED,
  VENUE_OWNERSHIPS_CHANGED,
  ROOMS_CHANGED,
  ROOMS_REORDERED,
  HOLD_POSITIONS_REORDERED
} from '../constants/calendarViewV2Constants';

import {
  utcToTimeZone
} from '../../../shared/timeZoneLogic';

export const updateSelectedVenue = (venues, selected) => ({
  type: VENUE_SELECTED_CHANGED,
  venues,
  selected
});

export const fetchCalendarEventsForSelectedVenues = (dispatch, team, selectedRooms, selectedTags, onSuccess = () => {}) => {
  return (dispatch, getState) => {
    var calendarView = getState().calendarView;

    if(!calendarView){
      return;
    }

    var includeEndTime = (
      ["calendar_weekly", "calendar_daily"].includes(calendarView.currentTeamMembership.calendar_view) ? "1" : "0"
    );

    return axios.get("/teams/" + team.id + "/calendar_events", {
        params: {
          v: "v2",
          tags: selectedTags,
          room_ids: selectedRooms.map((s) => s.value),
          start_of_month: calendarView.currentTeamMembership.calendar_starts_at,
          include_end_time: includeEndTime,
          time_zone: "UTC"
        }
      })
      .then(({ data }) => {
        let localizedEvents = data.calendar_events.map((event) => {
          return {
            ...event,
            start: (event.date ? utcToTimeZone(event.date, event.time_zone) : null),
            end: (event.end ? utcToTimeZone(event.end, event.time_zone) : null),
            date_range: event.date_range.map((d) => utcToTimeZone(d, event.time_zone))
          };
        });

        dispatch(updateAllEvents(localizedEvents));
        onSuccess(localizedEvents);
      })
  };
};

export const updateAllEvents = (events) => ({
  type: EVENTS_CHANGED,
  events
});

export const fetchTeamVenueConflicts = (dispatch, team, selectedRooms, user) => {
  return dispatch => {
    if(!user.can_manage_calendar_event_conflicts){
      return;
    }

    return axios.get("/teams/" + team.id + "/calendar_event_conflicts", {
        params: {
          room_ids: selectedRooms.map((s) => s.value)
        }
      })
      .then(({ data }) => {
        data.map((calendarEventConflict) => {
          calendarEventConflict.shouldMerge = true;
        });

        dispatch(calendarEventConflictsChanged(data));

        if(data.length > 0){
          dispatch(openCalendarEventConflictsModal());
        }
      })
  }
};

export const onInit = (dispatch, team, selectedRooms, selectedTags, user, dataTableFilters) => {
  dataTableFilters = Object.assign({}, dataTableFilters, {
    room_ids: selectedRooms.map((s) =>  s.value),
    tags: selectedTags,
  });

  return dispatch => {
    dispatch(fetchTeamVenueConflicts(dispatch, team, selectedRooms, user));
    dispatch(dataTableFiltersChanged(dataTableFilters));
  }
};

export const calendarEventConflictsChanged = (calendarEventConflicts) => ({
  type: CALENDAR_EVENT_CONFLICTS_CHANGED,
  calendarEventConflicts
});

export const openCalendarEventConflictsModal = () => ({
  type: OPEN_CALENDAR_EVENT_CONFLICTS_MODAL
});

export const closeCalendarEventConflictsModal = () => ({
  type: CLOSE_CALENDAR_EVENT_CONFLICTS_MODAL
});

export const confirmTeamVenueConflicts = (dispatch, csrfToken, team, calendarEventConflicts, selectedRooms, selectedTags) => {
  var mapping = calendarEventConflicts.map((calendarEventConflict) => {
    return {
      id: calendarEventConflict.id,
      resolution: (calendarEventConflict.shouldMerge ? "merge" : "ignore")
    };
  });

  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/calendar_event_conflicts/confirm", {
        mapping: mapping
      })
      .then(({ data }) => {
        dispatch(fetchCalendarEventsForSelectedVenues(dispatch, team, selectedRooms, selectedTags));
      })
  }
};

export const saveUserCalendarStartDay = (dispatch, csrfToken, calendarStartDay) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/user_settings", {
        user: {
          calendar_start_day: calendarStartDay
        }
      })
      .then(({ data }) => {
        dispatch(updateUser(data));
      })
  };
};

export const updateUser = (user) => ({
  type: USER_UPDATED,
  user
});

export const calendarEventConflictMergeCheckboxClicked = (calendarEventConflict, checked) => ({
  type: CALENDAR_EVENT_CONFLICTS_MERGE_CHECKBOX_CLICKED,
  calendarEventConflict,
  checked
});

export const toggleOnSaleEnabled = (onSaleEnabled) => ({
  type: TOGGLE_ON_SALE_ENABLED,
  onSaleEnabled
});

export const togglePreSaleEnabled = (preSaleEnabled) => ({
  type: TOGGLE_PRE_SALE_ENABLED,
  preSaleEnabled
});

export const toggleArtistPreSaleEnabled = (artistPreSaleEnabled) => ({
  type: TOGGLE_ARTIST_PRE_SALE_ENABLED,
  artistPreSaleEnabled
});

export const toggleAnnouncedEnabled = (announcedEnabled) => ({
  type: TOGGLE_ANNOUNCED_ENABLED,
  announcedEnabled
});

export const toggleConfirmedEnabled = (confirmedEnabled) => ({
  type: TOGGLE_CONFIRMED_ENABLED,
  confirmedEnabled
});

export const toggleHoldsEnabled = (holdsEnabled) => ({
  type: TOGGLE_HOLDS_ENABLED,
  holdsEnabled
});

export const togglePastEventsEnabled = (pastEventsEnabled) => ({
  type: TOGGLE_PAST_EVENTS_ENABLED,
  pastEventsEnabled
});

export const toggleCancelledEventsEnabled = (cancelledEventsEnabled) => ({
  type: TOGGLE_CANCELLED_EVENTS_ENABLED,
  cancelledEventsEnabled
});

export const dataTableFiltersChanged = (dataTableFilters) => ({
  type: DATA_TABLE_FILTERS_CHANGED,
  dataTableFilters
})

export const reloadDataTable = () => ({
  type: RELOAD_DATA_TABLE
})

export const dataTableElChanged = (el) => ({
  type: DATA_TABLE_EL_CHANGED,
  el
})

export const searchTermChanged = (term) => ({
  type: SEARCH_TERM_CHANGED,
  term
})

export const saveTeamMembershipCalendarState = (dispatch, csrfToken, team, teamMembership, teamMembershipParams, onSuccess = () => {}) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/teams/" + team.id + "/team_memberships/" + teamMembership.id, {
        team_membership: teamMembershipParams
      })
      .then(({ data }) => {
        onSuccess(data);
      });
  };
};

export const currentTeamMembershipChanged = (currentTeamMembership) => ({
  type: CURRENT_TEAM_MEMBERSHIP_CHANGED,
  currentTeamMembership
})

export const checkAvailsIsOpenChanged = (checkAvailsIsOpen) => ({
  type: CHECK_AVAILS_IS_OPEN_CHANGED,
  checkAvailsIsOpen
})

export const checkAvailsSettingsChanged = (checkAvailsSettings) => ({
  type: CHECK_AVAILS_SETTINGS_CHANGED,
  checkAvailsSettings
})

export const calendarSyncIsOpenChanged = (calendarSyncIsOpen) => ({
  type: CALENDAR_SYNC_IS_OPEN_CHANGED,
  calendarSyncIsOpen
})

export const checkAvailsDatesChanged = (checkAvailsDates) => ({
  type: CHECK_AVAILS_DATES_CHANGED,
  checkAvailsDates
})

export const checkAvailsCalendarEventsChanged = (checkAvailsCalendarEvents) => ({
  type: CHECK_AVAILS_CALENDAR_EVENTS_CHANGED,
  checkAvailsCalendarEvents
})

export const fetchCheckAvailsCalendarEvents = (dispatch, team, checkAvailsRooms, checkAvailsDates, signal) => {
  return (dispatch, getState) => {
    dispatch(checkAvailsLoadingChanged(true));

    var adjustedStartDate = new Date(checkAvailsDates[0]);
    adjustedStartDate.setDate(adjustedStartDate.getDate() - 14);

    var adjustedEndDate = new Date(checkAvailsDates[1]);
    adjustedEndDate.setDate(adjustedEndDate.getDate() + 14);

    return axios.get("/teams/" + team.id + "/calendar_events", {
        params: {
          room_ids: checkAvailsRooms.map((room) => room.value),
          start_date: adjustedStartDate,
          end_date: adjustedEndDate,
          time_zone: "UTC"
        },
        signal
      })
      .then(({ data }) => {
        if(signal.aborted){
          return;
        }

        let localizedEvents = data.calendar_events.map((event) => {
          return {
            ...event,
            start: (event.date ? utcToTimeZone(event.date, event.time_zone) : null),
            end: (event.end ? utcToTimeZone(event.end, event.time_zone) : null),
            date_range: event.date_range.map((date) => utcToTimeZone(date, event.time_zone))
          };
        });

        dispatch(checkAvailsCalendarEventsChanged(localizedEvents));
      }, () => {
        if(signal.aborted){
          return;
        }

        toastError("Could not check avails. Please try again.");
      })
      .finally(() => {
        if(signal.aborted){
          return;
        }

        dispatch(checkAvailsLoadingChanged(false));
      });
  };
};

export const checkAvailsLoadingChanged = (checkAvailsLoading) => ({
  type: CHECK_AVAILS_LOADING_CHANGED,
  checkAvailsLoading
})

export const venueOwnershipsChanged = (venueOwnerships) => ({
  type: VENUE_OWNERSHIPS_CHANGED,
  venueOwnerships
})

export const roomsChanged = (rooms) => ({
  type: ROOMS_CHANGED,
  rooms
})

export const reorderRooms = (csrfToken, team, reorderedRooms) => {
  return (dispatch, getState) => {
    const previousRooms = getState().calendarView.rooms;

    dispatch({ type: ROOMS_REORDERED, rooms: reorderedRooms });

    const positionMapping = reorderedRooms.reduce((acc, room, idx) => {
      acc[room.id] = idx + 1;
      return acc;
    }, {});

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/rooms/reorder_positions", {
        position_mapping: positionMapping
      })
      .catch(() => {
        toastError("Failed to reorder calendars. Please try again.");
        dispatch({ type: ROOMS_REORDERED, rooms: previousRooms });
      });
  };
};

export const reorderHoldPositions = (csrfToken, team, positionMapping, selectedRooms, selectedTags) => {
  return (dispatch) => {
    dispatch({ type: HOLD_POSITIONS_REORDERED, positionMapping });

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/hold_positions/reorder_positions", {
        position_mapping: positionMapping
      })
      .then(
        () => {
          dispatch(fetchCalendarEventsForSelectedVenues(dispatch, team, selectedRooms, selectedTags));
        },
        () => {
          toastError("Failed to reorder holds. Please try again.");
          dispatch(fetchCalendarEventsForSelectedVenues(dispatch, team, selectedRooms, selectedTags));
        }
      );
  };
};

export const clearHoldPosition = (csrfToken, team, holdPositionId, selectedRooms, selectedTags) => {
  return (dispatch) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/hold_positions/clear_hold_positions", {
        hold_position_ids: [holdPositionId]
      })
      .then(
        () => {
          toastSuccess("Hold cleared");
          dispatch(fetchCalendarEventsForSelectedVenues(dispatch, team, selectedRooms, selectedTags));
          return true;
        },
        () => {
          toastError("Failed to clear hold. Please try again.");
          return false;
        }
      );
  };
};